"use client"

import ErrorPage from "@/app/components/StatusPages/ErrorPage"
import { ActionButtons } from "@/app/components/StatusPages"
import { useParams } from "next/navigation"

interface ErrorProps {
  error: Error & { digest?: string }
}

/**
 * GlobalError component that handles application-wide errors with context-aware messaging
 */
export default function PostError({ error }: ErrorProps): JSX.Element {
  const params = useParams()

  return (
    <ErrorPage
      error={error}
      name="post-error"
      title="Post Not Available"
      description="We're having trouble loading this post. This could be temporary, or the post may have been removed."
    >
      <ActionButtons
        primaryAction={{
          text: "View Publication",
          href: params?.blogSlug
            ? `${decodeURIComponent(params.blogSlug as string)}`
            : "/home",
        }}
        secondaryAction={{
          text: "Try Again",
          onClick: () => window.location.reload(),
        }}
      />
    </ErrorPage>
  )
}
